import { render } from "./AIMLItsServicesComp.vue?vue&type=template&id=5d2112f9&scoped=true"
import script from "./AIMLItsServicesComp.vue?vue&type=script&lang=js"
export * from "./AIMLItsServicesComp.vue?vue&type=script&lang=js"

import "./AIMLItsServicesComp.vue?vue&type=style&index=0&id=5d2112f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2112f9"]])

export default __exports__